import dayjs from 'dayjs'
import { formatRatePercent } from '../../../domain/invoicing/taxRate'
import { formatTaxLocation } from '../../invoicing/TaxRates/taxRateSelectorModel'
import { WrongJurisdictionInvoice } from './taxJurisdictionAuditApi'

export type AuditRow = {
  key: string
  tenant: string
  invoiceNumber: string
  createdAt: string
  appliedRate: string
  resolvedLocation: string
  propertyLocation: string
}

export const toAuditRows = (invoices: WrongJurisdictionInvoice[]): AuditRow[] => {
  return [...invoices]
    .sort((a, b) => dayjs(b.createdAt).valueOf() - dayjs(a.createdAt).valueOf())
    .map(invoice => ({
      key: invoice.invoiceId,
      tenant: `${invoice.tenantName} (${invoice.tenantId})`,
      invoiceNumber: invoice.invoiceNumber,
      createdAt: dayjs(invoice.createdAt).format('MMM D, YYYY'),
      appliedRate: formatRatePercent(invoice.appliedRate),
      resolvedLocation: formatTaxLocation(invoice.resolvedLocation) ?? '—',
      propertyLocation: formatTaxLocation(invoice.propertyLocation) ?? '—',
    }))
}
